// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;When their breath goes forth, they return to the earth;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;on that day all their thoughts perish.<br> </p> </div></div>";
// Exports
module.exports = code;